import { useEffect, useState } from 'react';
import EfProductMultiSpec from '@elem/ui/ef-product-multi-spec';
import { formatMultiSpecData } from 'elem/utils/formatMultiSpecData';
import { productPageTheme, generalKeys } from '../../config/pageConfig';
import ProductNav from '../../common/ProductNav';
import styled from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useGlobal } from '@/utils/useGlobal';
import { getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import { productDetailData } from '@/service';

export interface GeneralKeyItemProps {
    key: string;
    url: string;
}

export default function TabSpecs() {
    const { gloproductlist } = useGlobal();
    const { locale = 'us' } = getLocal();
    const [productPageData, setProductPageData] = useState<any>({
        productCatagory: null,
        productSeries: [],
        supportDataArr: [],
    });

    useEffect(() => {
        const getProductSeriesData = async () => {
            const promiseAll = new Set();
            const proMsgAll: any[] = [];
            const productPageData = {
                productCatagory: null,
                productSeries: [] as any[],
                supportDataArr: [] as any[],
            };
            generalKeys?.map((item: { key: string }, _: number) => {
                const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: item.key });
                if (Object.keys(productMsg)?.length > 0) {
                    proMsgAll.push(productMsg);
                    promiseAll.add(productDetailData({ handle: productMsg.url }, locale || 'us'));
                }
            });

            Promise.all(promiseAll).then((resArr) => {
                resArr.map((resItem: any, resIndex) => {
                    if (resItem && resItem.code === '0') {
                        if (resIndex === 0) {
                            console.log('resItem', resItem);
                            productPageData.productCatagory = resItem?.data?.productCatagoryResponseList;
                        }
                        productPageData.productSeries.push(resItem?.data?.spuResponse);
                    }
                });

                setProductPageData(productPageData);
            });
        };

        getProductSeriesData();
    }, []);
    return (
        <>
            <ProductNav activeTab={'Specs'} />
            {productPageData?.productCatagory && productPageData?.productSeries?.length > 0 && (
                <EfProductMultiSpec
                    className={styled.streamSpecs}
                    items={[...productPageData?.productSeries]}
                    catagories={formatMultiSpecData(productPageData?.productCatagory, [...productPageData?.productSeries])}
                    theme={productPageTheme}
                />
            )}
        </>
    );
}
